import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { MailWarning, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";

export default function EmailReminder() {
  const { user, resendVerification } = useAuth();
  const { t } = useLang();
  const nav = useNavigate();
  const [busy, setBusy] = useState(false);

  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setBusy(true);
    try {
      const data = await resendVerification();
      if (data?.dev_verify_url) {
        toast.info(t("email_inactive_toast"));
        const url = data.dev_verify_url;
        if (url.startsWith(window.location.origin)) nav(url.slice(window.location.origin.length));
        else window.location.href = url;
      } else {
        toast.success(t("email_resent_toast"));
      }
    } catch (e) {
      toast.error(e.response?.data?.detail || t("try_again_moment"));
    } finally { setBusy(false); }
  };

  return (
    <div className="mx-4 mt-3 flex items-center gap-3 rounded-2xl px-3.5 py-2.5 bg-amber-50 border border-amber-200" data-testid="email-reminder">
      <MailWarning size={18} className="text-amber-600 shrink-0" />
      <span className="flex-1 text-xs font-medium text-amber-800 leading-snug">{t("email_confirm_banner")}</span>
      <button onClick={resend} disabled={busy} data-testid="resend-verification-btn" className="text-xs font-bold text-amber-700 whitespace-nowrap press disabled:opacity-60">
        {busy ? <Loader2 size={13} className="animate-spin" /> : t("resend_word")}
      </button>
    </div>
  );
}
